import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import IconButton from "@material-ui/core/IconButton";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1500 },
    items: 5,
  },
  smallDesktop: {
    breakpoint: { max: 1500, min: 1200 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1200, min: 800 },
    items: 3,
  },
  smallTablet: {
    breakpoint: { max: 800, min: 500 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 500, min: 0 },
    items: 1,
  },
};

class Carousel extends Component {
  state = {
    width: 0,
    count: 0,
    index: 0,
    items: this.props.items || [],
    slide: true,
    direction: "",
    loop: true,
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    window.addEventListener("keydown", this.keyNavigation);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.isSelected &&
      this.props.selected.Objektnr !== prevProps.selected.Objektnr
    ) {
      if (this.state.loop) {
        var index = this.state.items.findIndex(
          (item) => item.properties.Objektnr === this.props.selected.Objektnr
        );
        this.setState({ items: this.breakpoint(this.state.items, index) });
      }
    }
    if (
      prevProps.items !== this.props.items &&
      prevProps.pdf === this.props.pdf &&
      prevProps.prompt === this.props.prompt
    ) {
      var displayedItems = this.state.items;
      if (this.state.loop) {
        // eslint-disable-next-line
        var { displayedItems } = this.calculateItems();
      }
      var stateItems = displayedItems.filter((item) => {
        return this.props.items.includes(item);
      });
      var newItems = this.props.items.filter((item) => {
        return !stateItems.includes(item);
      });
      if (
        stateItems.filter(
          (item) =>
            item.properties &&
            item.properties.Objektnr === this.props.selected.Objektnr
        ).length > 0
      ) {
        stateItems.push(...newItems);
      } else {
        stateItems = this.props.items;
      }

      var loop;
      if (stateItems.length > this.state.count) {
        loop = true;
      } else {
        loop = false;
      }
      this.setState({ items: stateItems, loop, index: 0 });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    window.removeEventListener("keydown", this.keyNavigation);
  }

  updateWindowDimensions = () => {
    var width = window.innerWidth;
    var count =
      width > responsive.desktop.breakpoint.min
        ? responsive.desktop.items
        : width > responsive.smallDesktop.breakpoint.min
        ? responsive.smallDesktop.items
        : width > responsive.tablet.breakpoint.min
        ? responsive.tablet.items
        : width > responsive.smallTablet.breakpoint.min
        ? responsive.smallTablet.items
        : responsive.mobile.items;
    var loop = false;
    if (this.state.items.length > count) {
      loop = true;
    }
    this.setState({ width, count, loop });
  };

  keyNavigation = (event) => {
    if (this.props.theme === this.props.carousel) {
      if (this.state.loop) {
        if (event.key === "ArrowLeft" || event.keyCode === 37) {
          this.back();
        }
        if (event.key === "ArrowRight" || event.keyCode === 39) {
          this.next();
        }
      }
    }
  };

  breakpoint = (items, index) => {
    var tabletItems;
    if (this.state.width > responsive.desktop.breakpoint.min) {
      tabletItems = [...items, ...items, ...items];
      items = [
        ...tabletItems.slice(
          index - 1 + items.length - 1,
          index + items.length + 1
        ),
      ].concat(
        tabletItems.slice(
          index + items.length + 1,
          items.length * 2 + index - 2
        )
      );
    } else if (this.state.width > responsive.tablet.breakpoint.min) {
      tabletItems = [...items, ...items, ...items];
      items = [
        ...tabletItems.slice(
          index + items.length - 1,
          index + items.length + 1
        ),
      ].concat(
        tabletItems.slice(
          index + items.length + 1,
          items.length * 2 + index - 1
        )
      );
    } else {
      items = [items[index]]
        .concat(items.slice(index + 1, items.length))
        .concat(items.slice(0, index));
    }
    return items;
  };

  next = () => {
    var index = this.state.index + 1;
    if (index > 0) {
      index = index % this.state.items.length;
    } else {
      index = index + this.state.items.length;
    }
    this.setState({ slide: false }, () => {
      this.setState({ index, direction: "left", slide: true });
    });
  };

  back = () => {
    var index = this.state.index - 1;
    if (index > 0) {
      index = index % this.state.items.length;
    } else {
      index = index + this.state.items.length;
    }
    this.setState({ slide: false }, () => {
      this.setState({ index, direction: "right", slide: true });
    });
  };

  calculateItems = () => {
    var displayedItems = this.state.items.slice(
      this.state.index,
      this.state.index + this.state.count
    );
    for (var i = 0; displayedItems.length < this.state.count; i++) {
      displayedItems.push(this.state.items[i]);
    }

    var hiddenItem;
    if (this.state.direction === "right") {
      hiddenItem =
        this.state.items[
          (this.state.index + this.state.count) % this.state.items.length
        ];
    } else {
      if (this.state.index > 0) {
        hiddenItem = this.state.items[this.state.index - 1];
      } else {
        hiddenItem =
          this.state.items[this.state.index - 1 + this.state.items.length];
      }
    }
    return { displayedItems, hiddenItem };
  };

  render() {
    var displayedItems, hiddenItem;
    if (this.state.loop) {
      // eslint-disable-next-line
      var { displayedItems, hiddenItem } = this.calculateItems();
      if (this.props.renderHidden) {
        hiddenItem = this.props.renderHidden([hiddenItem])[0];
      } else {
        hiddenItem = this.props.render([hiddenItem])[0];
      }
    } else {
      displayedItems = this.state.items;
    }
    displayedItems = this.props.render(displayedItems);
    return (
      <div>
        {this.state.loop ? (
          <div
            style={{ display: "flex", alignItems: "center", height: "100%" }}
          >
            <div
              style={{
                backgroundColor: "white",
                marginLeft: "-15px",
                width: "15px",
                height: "53px",
                zIndex: 1,
              }}
            ></div>
            <div
              style={{
                border: "5px solid white",
                borderRadius: "0% 50% 50% 0%",
                zIndex: 1,
                backgroundColor: "white",
              }}
            >
              <IconButton
                onClick={this.back}
                className={"carousel-button"}
                style={{
                  backgroundColor: "#00568E",
                  fill: "white",
                  width: "43px",
                  height: "43px",
                  padding: 0,
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="30px"
                  viewBox="0 0 24 24"
                  width="30px"
                  fill="inherit"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                </svg>
              </IconButton>
            </div>
            {this.state.slide ? (
              <div
                style={{ width: "100%", display: "flex", overflow: "hidden" }}
              >
                {this.state.direction === "left" ? (
                  <div
                    className={"carousel-transition-next-hidden"}
                    style={{
                      visibility: "hidden",
                      position: "fixed",
                      left: `calc((100% / ${this.state.count} - 20px - 43px) * -1)`,
                      width: `calc(100% / ${this.state.count} - 43px / 2)`,
                    }}
                  >
                    {hiddenItem}
                  </div>
                ) : null}

                <div style={{ display: "flex", width: "100%" }}>
                  {displayedItems.map((item, i) => {
                    return (
                      <div
                        key={i}
                        className={
                          this.state.direction === "right"
                            ? "carousel-transition-back"
                            : "carousel-transition-next"
                        }
                        style={{ width: `calc(100% / ${this.state.count})` }}
                      >
                        {item}
                      </div>
                    );
                  })}
                </div>

                {this.state.direction === "right" ? (
                  <div
                    className={"carousel-transition-back-hidden"}
                    style={{
                      visibility: "hidden",
                      position: "fixed",
                      right: `calc((100% / ${this.state.count} - 20px - 43px) * -1)`,
                      width: `calc(100% / ${this.state.count} - 43px / 2)`,
                    }}
                  >
                    {hiddenItem}
                  </div>
                ) : null}
              </div>
            ) : null}
            <div
              style={{
                border: "5px solid white",
                borderRadius:
                  this.props.theme === "images" ? "50%" : "50% 0% 0% 50%",
                zIndex: 1,
                backgroundColor: "white",
              }}
            >
              <IconButton
                onClick={this.next}
                className={"carousel-button"}
                style={{
                  backgroundColor: "#00568E",
                  fill: "white",
                  width: "43px",
                  height: "43px",
                  padding: 0,
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="30px"
                  viewBox="0 0 24 24"
                  width="30px"
                  fill="inherit"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                </svg>
              </IconButton>
            </div>
            {/* <div
              style={{
                backgroundColor: "white",
                marginRight: "-15px",
                width: "15px",
                height: "53px",
                zIndex: 1,
              }}
            ></div> */}
          </div>
        ) : (
          <div
            style={{ margin: "0 43px", display: "flex", overflow: "hidden" }}
          >
            {displayedItems.map((item, i) => {
              return (
                <div
                  key={i}
                  className={
                    this.state.direction === "right"
                      ? "carousel-transition-back"
                      : "carousel-transition-next"
                  }
                  style={{ width: `calc(100% / ${this.state.count})` }}
                >
                  {item}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

Carousel.propTypes = {
  selected: PropTypes.object.isRequired,
  pdf: PropTypes.bool.isRequired,
  prompt: PropTypes.bool.isRequired,
  carousel: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  selected: state.mill.selected,
  pdf: state.mill.pdf,
  prompt: state.settings.prompt,
  carousel: state.settings.carousel,
});

export default connect(mapStateToProps, {})(Carousel);
